(function() {
  'use strict';
  angular.module('benefits')
    .component('planInfo', {
      bindings: {
        refId: '='
      },
      controller: ['benefitService','planFormat','$scope', function memberInfoController(benefitService, planFormat, $scope) {
        var maxTemplate = {
          'maximum' :{
            'benefitPeriod' :{
              'individual': {}, 'family':{}
            },
            'lifetime':{
              'individual': {}, 'family':{}
            },
          }
        };
        var deductibleTemplate = {
          'deductible':{
            'benefitPeriod' :{
              'individual': {}, 'family':{}
            },
            'lifetime':{
              'individual': {}, 'family':{}
            },
          }
        };

        var outOfPockedTemplate = {
          'outOfPocket': {
            'benefitPeriod' :{
              'individual': {}, 'family':{}
            }
          }
        };
        this.$onInit = function() {
          $scope.running = true;
          benefitService.planAccumPromise.then(function(data) {
            //make object null safe
            var nullSafePlan = _.merge(data,
              data.maximum ? maxTemplate : {},
              data.deductible ? deductibleTemplate : {},
              data.outOfPocket ? outOfPockedTemplate : {});
            $scope.plan = planFormat.planAccumFilter(nullSafePlan);
            $scope.planType = data.planType;
            $scope.serviceUnavailable = data.serviceUnavailable;
            $scope.running = false;
          });
          benefitService.checkPolicyForBenefitBlock(this.refId).then(function(data) {
            $scope.isBenefitBlock = data;
          });
        };
      }],
      templateUrl: 'js/benefits/planInfo.html' + appVersion
    });
})();
